//import logo from "./logo.svg";
import React, { Suspense, lazy } from "react";
import "./App.css";
import "./admin-redesign.css";
import "./admin-layout-redesign.css";
import { Helmet } from "react-helmet";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProgressIndicator from "./ProgressIndicator";
import DebugPanel from './debug/DebugPanel';


const SignIn = lazy(() => import('./features/auth/sign-in-page'));
const ForgotPassword = lazy(() => import('./features/auth/forgot-password-page'));
const ResetPassword = lazy(() => import('./features/auth/reset-password-page'));
const Dashboard = lazy(() => import('./dashboard'));
const ReviewJobs = lazy(() => import('./Components/ReviewJob/reviewJob'))
const ProtectedRoute = lazy(() => import('./features/auth/protected-route'));

function App() {
  return (
    <div className="App">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link 
          href="https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap" 
          rel="stylesheet" 
        />
        <link 
          href="https://fonts.googleapis.com/css2?family=Aldrich&display=swap"
          rel="stylesheet" 
        />
      </Helmet>

      <ProgressIndicator />
      
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            {/* Main Routes */}
            <Route index element={<SignIn />} />
            <Route path='/sign-in' element={<SignIn />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path='/dashboard' element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
            <Route path='/dashboard/:tab/:id?' element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
            <Route path="/dashboard/chat" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
            <Route path="/dashboard/chat/:chatId" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />

            <Route path="/review-jobs" element={<ReviewJobs />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
      <DebugPanel />
    </div>
  );
}

export default App;
